export default __webpack_public_path__ + "static/media/person-f3.1e636408.jpeg";